

/**
 * @deprecated 
 * Do not use anymore.
 * Use `RNIUtilitiesModule.` instead.
 */
export type NotifyOnComponentWillUnmount = (
  reactTag: number,
  isManuallyTriggered: boolean
) => Promise<void>;